import { render, staticRenderFns } from "./MsgEntityCollectionEmpty.vue?vue&type=template&id=19d404d6&scoped=true&"
import script from "./MsgEntityCollectionEmpty.vue?vue&type=script&lang=js&"
export * from "./MsgEntityCollectionEmpty.vue?vue&type=script&lang=js&"
import style0 from "./MsgEntityCollectionEmpty.vue?vue&type=style&index=0&id=19d404d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d404d6",
  null
  
)

export default component.exports